module.exports = require('./dist/server')



//////////////////
// WEBPACK FOOTER
// ../node_modules/styled-jsx/server.js
// module id = ../node_modules/styled-jsx/server.js
// module chunks = 1